/* DOMNO. spin popup v2, part 1 of 2: settings, wheel art, spin physics, sheet and steps. Part 2 is domno-spin-2.js. */
(function () {
  'use strict';
  var root = document.getElementById('ds-root');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');
  if (root.parentNode !== document.body) document.body.appendChild(root);

  var CFG = {
    companyId: 'STCDP5',
    listEmail: 'Xbtg9k',
    listSms: 'SdCkKR',
    codeEndpoint: 'https://spin.domno.com/code',
    revision: '2025-01-15',
    delayMs: 5000,
    snoozeDays: 5,
    variant: 'spin_wheel_v4',
    theme: 'blackgrey', // wheel colours, see domno-spin-skins.css
    source: 'DOMNO spin wheel v4',
    smsCountries: ['GB', 'US', 'CA', 'AU', 'NZ', 'IE'],
    // Six slices, same layout as Nala. Only win:true slices can be landed on.
    slices: [
      { l1: 'MYSTERY', l2: 'DISCOUNT', win: false },
      { l1: '15%', l2: 'OFF', win: true },
      { l1: '30%', l2: 'OFF', win: false },
      { l1: 'MYSTERY', l2: 'DISCOUNT', win: false },
      { l1: '15%', l2: 'OFF', win: true },
      { l1: '30%', l2: 'OFF', win: false }
    ]
  };

  var qs = new URLSearchParams(location.search);
  var dp = qs.get('dp');
  var DEMO = dp === 'spin';
  var FORCE_LIVE = dp === 'spinlive';
  var reduced = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var isPhone = function () { return !(window.matchMedia && matchMedia('(min-width: 640px)').matches); };

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return localStorage.getItem('ds_' + k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem('ds_' + k, v); } catch (e) {} },
    sget: function (k) { try { return sessionStorage.getItem('ds_' + k); } catch (e) { return null; } },
    sset: function (k, v) { try { sessionStorage.setItem('ds_' + k, v); } catch (e) {} }
  };
  var state = { step: 'wheel', won: false, spinning: false, rot: 0, email: '', name: '', code: '' };
  var N = CFG.slices.length, STEP = 360 / N, PEG = STEP / 2;
  var rotEl = $('.ds-rot'), pinEl = $('.ds-pin'), card = $('.ds-card');

  function track() { var t = window.__ds && window.__ds.track; if (t) t.apply(null, arguments); }
  function buzz(p) { try { if (navigator.vibrate) navigator.vibrate(p); } catch (e) {} }

  /* ---------- wheel art: flat slices, colours come from the theme in domno-spin.css ---------- */
  function drawWheel() {
    var R = 178;
    function pt(deg, r) { var a = (deg - 90) * Math.PI / 180; return [(200 + r * Math.cos(a)).toFixed(2), (200 + r * Math.sin(a)).toFixed(2)]; }
    var h = '<circle class="ds-rim" cx="200" cy="200" r="198"/>';
    CFG.slices.forEach(function (s, i) {
      var p0 = pt(i * STEP - STEP / 2, R), p1 = pt(i * STEP + STEP / 2, R);
      var d = 'M200,200 L' + p0[0] + ',' + p0[1] + ' A' + R + ',' + R + ' 0 0 1 ' + p1[0] + ',' + p1[1] + ' Z';
      var big = s.l1.length <= 4;
      h += '<g class="ds-slice ds-s' + i + '" data-i="' + i + '"><path class="ds-fill" d="' + d + '"/><path class="ds-glow" d="' + d + '"/>' +
        '<g class="ds-lab" transform="rotate(' + (i * STEP) + ' 200 200)">' +
        (big
          ? '<text x="200" y="74" text-anchor="middle" font-size="44">' + s.l1 + '</text><text x="200" y="100" text-anchor="middle" font-size="21">' + s.l2 + '</text>'
          : '<text x="200" y="68" text-anchor="middle" font-size="21">' + s.l1 + '</text><text x="200" y="92" text-anchor="middle" font-size="18">' + s.l2 + '</text>') +
        '</g></g>';
    });
    h += '<circle class="ds-ring" cx="200" cy="200" r="' + R + '"/>';
    $('.ds-wheel').innerHTML = h;
  }

  function setRot(r) { state.rot = r; rotEl.style.transform = 'rotate(' + r + 'deg)'; }

  /* ---------- idle drift: the wheel turns slowly while it waits for a tap ---------- */
  var idleOn = false;
  function idle() {
    if (idleOn || reduced) return;
    idleOn = true;
    var last = performance.now();
    (function step(now) {
      if (!idleOn || state.spinning || state.won || !root.classList.contains('is-open')) { idleOn = false; return; }
      setRot(state.rot + (now - last) * 0.009); // about one turn every 40 seconds
      last = now;
      requestAnimationFrame(step);
    })(last);
  }

  /* ---------- spin: wind-up, long ease-out, overshoot, settle ---------- */
  function spin() {
    if (state.spinning || state.won) return;
    state.spinning = true; idleOn = false;
    root.classList.add('is-spun');
    $$('[data-ds-spin]').forEach(function (b) { b.disabled = true; });
    var sb = $('.ds-btn[data-ds-spin]'); if (sb) sb.textContent = 'Good luck...';
    track('Spin Popup Spun', {});
    var winners = [];
    CFG.slices.forEach(function (s, i) { if (s.win) winners.push(i); });
    var pick = winners[Math.floor(Math.random() * winners.length)];
    var side = Math.random() < 0.5 ? -1 : 1;
    var jitter = side * (STEP * 0.12 + Math.random() * STEP * 0.24); // rests between pegs, never on a divider
    var a0 = state.rot;
    var landing = ((-(pick * STEP) - a0) % 360 + 360) % 360;
    var target = a0 + 7 * 360 + landing + jitter;
    if (reduced) { setRot(target); return landed(pick); }

    var WIND = 300, MAIN = 4800, SETTLE = 650, OVER = 4.5;
    var startA = a0 - 11, endMain = target + OVER;
    var t0 = performance.now(), prev = a0, slot = Math.floor(a0 / PEG), pin = 0;
    function easeMain(p) { return 1 - Math.pow(1 - p, 3.4); }
    function frame(now) {
      var t = now - t0, r;
      if (t < WIND) { var w = t / WIND; r = a0 - 11 * (0.5 - Math.cos(Math.PI * w) / 2); }
      else if (t < WIND + MAIN) { r = startA + (endMain - startA) * easeMain((t - WIND) / MAIN); }
      else if (t < WIND + MAIN + SETTLE) { var s2 = (t - WIND - MAIN) / SETTLE; r = target + OVER * (1 - (s2 < .5 ? 4 * s2 * s2 * s2 : 1 - Math.pow(-2 * s2 + 2, 3) / 2)); }
      else r = target;
      setRot(r);
      var speed = Math.abs(r - prev); prev = r;
      var ns = Math.floor(r / PEG);
      if (ns !== slot) {
        slot = ns;
        pin = -Math.min(30, 10 + speed * 1.6);
        if (speed < 7) buzz(4);
      }
      pin += (0 - pin) * 0.3;
      pinEl.style.transform = 'rotate(' + pin.toFixed(2) + 'deg)';
      if (t < WIND + MAIN + SETTLE + 60) requestAnimationFrame(frame);
      else { pinEl.style.transform = ''; landed(pick); }
    }
    requestAnimationFrame(frame);
  }

  function markWon(i) {
    state.won = true;
    root.classList.add('is-won', 'is-spun');
    $$('[data-ds-spin]').forEach(function (b) { b.disabled = true; });
    var g = $('.ds-slice[data-i="' + i + '"]');
    if (g) g.classList.add('is-win');
  }

  function landed(i) {
    state.spinning = false;
    store.sset('won', '1');
    markWon(i);
    buzz([12, 50, 22]);
    confetti();
    setTimeout(function () { goto('form'); }, reduced ? 300 : 1400);
  }

  /* ---------- confetti (canvas, silver / red / black) ---------- */
  function confetti() {
    if (reduced) return;
    var c = $('.ds-confetti'), cr = card.getBoundingClientRect(), wr = $('.ds-wheelwrap').getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    c.width = cr.width * dpr; c.height = cr.height * dpr;
    var ctx = c.getContext('2d'); ctx.scale(dpr, dpr);
    var ox = wr.left - cr.left + wr.width / 2, oy = wr.top - cr.top + wr.height * 0.42;
    var cv = getComputedStyle(root).getPropertyValue('--confetti').trim();
    var cols = cv ? cv.split(',') : ['#ff0000', '#0b0b0b', '#c9cdd2', '#e9ebee', '#8d939a'], P = [];
    for (var k = 0; k < 70; k++) {
      var a = (-90 + (Math.random() - 0.5) * 150) * Math.PI / 180, v = 6 + Math.random() * 9;
      P.push({ x: ox, y: oy, vx: Math.cos(a) * v, vy: Math.sin(a) * v, w: 7 + Math.random() * 6, h: 4 + Math.random() * 4,
        r: Math.random() * 6.3, vr: (Math.random() - .5) * .35, t: Math.random() * 6.3, vt: .08 + Math.random() * .12, c: cols[k % cols.length] });
    }
    var start = performance.now();
    (function tick(now) {
      ctx.clearRect(0, 0, cr.width, cr.height);
      var life = (now - start) / 2200, alive = false;
      P.forEach(function (p) {
        p.vy += 0.28; p.vx *= 0.985; p.vy *= 0.985; p.x += p.vx; p.y += p.vy; p.r += p.vr; p.t += p.vt;
        if (p.y < cr.height + 20) alive = true;
        ctx.save(); ctx.globalAlpha = Math.max(0, 1 - Math.max(0, life - .6) * 2.5);
        ctx.translate(p.x, p.y); ctx.rotate(p.r); ctx.scale(1, Math.cos(p.t));
        ctx.fillStyle = p.c; ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h); ctx.restore();
      });
      if (alive && life < 1) requestAnimationFrame(tick); else ctx.clearRect(0, 0, cr.width, cr.height);
    })(start);
  }

  /* ---------- sheet: open, close, drag to dismiss ---------- */
  var lastFocus = null;
  function fitViewport() {
    var vv = window.visualViewport;
    root.style.setProperty('--vvh', (vv ? vv.height : window.innerHeight) + 'px');
  }
  function open(step) {
    lastFocus = document.activeElement;
    fitViewport();
    root.hidden = false;
    root.classList.remove('is-teaser', 'is-closing', 'is-open');
    $('[data-ds-teaser]').hidden = true;
    goto(step || (state.won ? 'form' : 'wheel'), true);
    void card.offsetWidth;
    requestAnimationFrame(function () { root.classList.add('is-open'); idle(); });
    document.addEventListener('keydown', onKey);
  }
  function close() {
    if (state.spinning || !root.classList.contains('is-open')) return;
    document.removeEventListener('keydown', onKey);
    root.classList.remove('is-open', 'is-dragging');
    root.classList.add('is-closing');
    card.style.transform = '';
    if (state.step !== 'code') store.set('snooze', String(Date.now() + CFG.snoozeDays * 864e5));
    setTimeout(function () {
      root.classList.remove('is-closing');
      root.hidden = true; // closed means gone (no corner tab)
    }, 320);
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }
  function onKey(e) { if (e.key === 'Escape') close(); }

  (function dragToDismiss() {
    var startY = 0, lastY = 0, lastT = 0, vel = 0, dragging = false;
    function down(e) {
      if (!isPhone() || state.spinning || e.target.closest('input,select,button,a')) return;
      if (!e.target.closest('.ds-grab,.ds-head') && $('.ds-scroll').scrollTop > 0) return;
      dragging = true; startY = lastY = e.clientY; lastT = performance.now(); vel = 0;
      root.classList.add('is-dragging');
    }
    function move(e) {
      if (!dragging) return;
      var dy = Math.max(0, e.clientY - startY), now = performance.now();
      vel = (e.clientY - lastY) / Math.max(1, now - lastT); lastY = e.clientY; lastT = now;
      card.style.transform = 'translateY(' + dy + 'px)';
    }
    function up(e) {
      if (!dragging) return;
      dragging = false;
      var dy = Math.max(0, (e.clientY || lastY) - startY);
      if (dy > 110 || vel > 0.6) { close(); }
      else { root.classList.remove('is-dragging'); card.style.transform = ''; }
    }
    $('.ds-grab').addEventListener('pointerdown', down);
    $('.ds-head').addEventListener('pointerdown', down);
    window.addEventListener('pointermove', move, { passive: true });
    window.addEventListener('pointerup', up);
    window.addEventListener('pointercancel', up);
  })();

  /* ---------- steps: wheel -> form -> code (the wheel bows out after the spin) ---------- */
  function goto(name, instant) {
    var body = $('.ds-body'), from = body.offsetHeight;
    root.classList.toggle('is-none', name !== 'wheel');
    $$('.ds-step').forEach(function (s) { s.hidden = s.getAttribute('data-step') !== name; s.classList.remove('is-entering'); });
    var cur = $('.ds-step[data-step="' + name + '"]');
    state.step = name;
    if (name !== 'wheel') $('.ds-scroll').scrollTo({ top: 0, behavior: instant ? 'auto' : 'smooth' });
    if (instant || reduced || !from) { body.style.height = ''; return; }
    var to = cur.offsetHeight;
    body.style.height = from + 'px';
    void body.offsetHeight;
    cur.classList.add('is-entering');
    requestAnimationFrame(function () { body.style.height = to + 'px'; });
    setTimeout(function () { body.style.height = ''; }, 520);
  }

  if (window.visualViewport) window.visualViewport.addEventListener('resize', fitViewport);
  root.addEventListener('focusin', function (e) {
    if (e.target.matches('input') && isPhone()) setTimeout(function () { try { e.target.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (x) {} }, 280);
  });
  $$('[data-ds-spin]').forEach(function (b) { b.addEventListener('click', spin); });

  root.setAttribute('data-theme', (DEMO && /^(blackgrey)$/.test(qs.get('ds_theme') || '')) ? qs.get('ds_theme') : CFG.theme);
  drawWheel();
  window.__ds = {
    root: root, CFG: CFG, qs: qs, DEMO: DEMO, FORCE_LIVE: FORCE_LIVE, $: $, $$: $$,
    store: store, state: state, goto: goto, open: open, close: close, spin: spin, markWon: markWon, setRot: setRot
  };
})();